import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const StateContext = createContext({
});

const initialState = {
    chat: false,
    cart: false,
    userProfile: false,
    notification: false,
}

export const ContextProvider = ({ children }) => {
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [activeMenu, setActiveMenu] = useState(true);
    const [isClicked, setIsClicked] = useState(initialState);
    const [screenSize, setScreenSize] = useState(undefined);
    const [currentColor, setCurrentColor] = useState('#1A97F5');
    const [currentMode, setCurrentMode] = useState('Dark');
    const [themeSettings, setThemeSettings] = useState(false);
    const [auth, setAuth] = useState();
    const [clientData, setClientData] = React.useState([]);
    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [openErrorModal, setOpenErrorModal] = React.useState(false);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);

    const [loading, setLoading] = useState(false);


    // Login
    const [values, setValues] = React.useState({
        email: '',
        password: '',
        showpassword: false
    });
    
    // const navigate = useNavigate();

    const setMode = (e) => {
        setCurrentMode(e.target.value);
        localStorage.setItem('themeMode', e.target.value);
        setThemeSettings(false);
    }

    const setColor = (color) => {
        setCurrentColor(color);
        localStorage.setItem('colorMode', color);
        setThemeSettings(false);
    }


    const handleClick = (clicked) => {
        setIsClicked({ ...initialState, [clicked]: true });
    }

    // SignOut
    const handleSignout = () => {
        window.localStorage.clear();
        setLoading(false);
    }

    return (
        <StateContext.Provider
            value={{
                activeMenu,
                setActiveMenu,
                isClicked,
                setIsClicked,
                handleClick,
                screenSize,
                setScreenSize,
                currentColor,
                currentMode,
                setCurrentColor,
                setCurrentMode,
                setMode,
                setColor,
                themeSettings,
                setThemeSettings,
                setValues,
                values,
                loading, auth, setAuth, setLoading, handleSignout,
                successMessage, setSuccessMessage, errorMessage, setErrorMessage,
                clientData, setClientData, openSuccessModal, setOpenSuccessModal,
                openErrorModal, setOpenErrorModal, openDeleteModal, setOpenDeleteModal

            }}
        >
            {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext);